// extracted by mini-css-extract-plugin
module.exports = {"between":"styles_between__3PmGk","logo":"styles_logo__25Q45"};